const buttonSize = 'pt-[11px] pb-[11px] pr-[20px] pl-[20px]';
const buttonTypography = 'font-[500] text-[15px] line-height-[20px]';

export const ButtonPrimary = `bg-[#EE3E5C] ${buttonSize} ${buttonTypography}`;

export const ButtonPrimaryDisabled = `border border-[#CFD6DA] bg-[#0E314508] text-[#B7C1C7] ${buttonSize} ${buttonTypography} pointer-events-none shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]`;
